var WebUtils = require('./WebUtils.js');

var loadingMessages = [
    "Plagiarising Hearthstone",
    "Thinking of funny things to write here",
    "Making sure you don't get bored",
    ["Knock knock", "Who's there", "A self aware test to pass loading time"],
    ["Hello Dave.", "Wait, your name isn't Dave?", "I was sure I wrote your name here somewhere", "Oh here it is", "Funny you don't look like a Steve"],
    "Sorry to keep you waiting",
    ["It's going to be worth it", "I promise", "Pinky swear"],
    "Anything is possible at Zombo... err... opherv.com",
    "Verbing adjectives",
    ["Gloating", "Did I say Gloating? I meant loading"],
    ["Downloading required file","Ooops, wrong file", "Pffft.. 'required'. It's all subjective anyhow"],
    ["This shouldn't take long at all", "(I think)"],
    "How about that weather we're having?",
    ["You know - It's not easy being a loading bar", "The hours are long", "The pay sucks", "Nobody appreciates what you do", "Everybody wants you to go away"],
    "Constructing additional pylons",
    "Placing the princesss in another castle",
    "Loading",
    "Downloading files",
    "Retrieving assets",
    "Compiling code",
    "Visualizing models",
    "Computing physics"
];

var instance;

var Loader = function(){
    this.currentMessageIndex = null;
    this.currentMessageSequenceIndex = null;
    this.messageEl = document.querySelector(".loaderContainer .caption");
    instance = this;
};

Loader.getInstance = function(){
    return instance;
};

Loader.prototype.startLoaderText = function(){
    var that = this;

    var randomTimeout = 2 + Math.random() * 5;
    //todo ugly - fix
    this.changeMessageTimeout = setTimeout(doChangeMessage,9000);

    function doChangeMessage(){
        that.nextMessage();
        randomTimeout = 6000; // + Math.random() * 1000;
        setTimeout(doChangeMessage,randomTimeout);
    }
};

Loader.prototype.afterDone = function(callback){
    var that = this;
    this.callback  = callback;

    document.querySelector('.loaderContainer').addEventListener("click",this.callback);
    clearTimeout(this.changeMessageTimeout);

    that.messageEl.classList.add("waitForDone");

    var divs = document.querySelectorAll('.loader div');
    var divCount = 0;
    [].forEach.call(divs, function(el) {
        WebUtils.one(el,"animationiteration webkitAnimationIteration",function(){
            el.classList.add("done");
            divCount++;
            if (divCount == divs.length){
                that.messageEl.innerHTML = "Create World";
                document.querySelector('.loaderContainer').classList.add("done");
            }
        })
    });

};

Loader.prototype.nextMessage = function(){
    var that = this;
    var messageText;

    if (this.currentMessageIndex == null){
        this.currentMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
        messageText = getMessageText(this.currentMessageIndex);
        setMessage.call(this, messageText);
        if (this.currentMessageSequenceIndex != null){
            this.currentMessageSequenceIndex++;
        }
    }
    else if (this.currentMessageSequenceIndex === null){
        var lastMessageIndex = this.currentMessageIndex;
        var newMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
        while(newMessageIndex == lastMessageIndex){
            newMessageIndex = WebUtils.getRandomInt(0, loadingMessages.length);
        }
        this.currentMessageIndex = newMessageIndex;
        messageText = getMessageText(this.currentMessageIndex);
        setMessage.call(this, messageText);
        if (this.currentMessageSequenceIndex != null){
            this.currentMessageSequenceIndex++;
        }
    }
    //more messages in the queue
    else if (this.currentMessageSequenceIndex < loadingMessages[this.currentMessageIndex].length){
            setMessage.call(this, loadingMessages[this.currentMessageIndex][this.currentMessageSequenceIndex]);
            this.currentMessageSequenceIndex++;
        }
    else{
        //we're at the last line
        this.currentMessageSequenceIndex = null;
        this.nextMessage();
    }
    
    function getMessageText(index){
        that.currentMessageIndex = index;
        if (Array.isArray(loadingMessages[index])){
            that.currentMessageSequenceIndex = 0;

            return loadingMessages[index][0];
        }
        else{
            that.currentMessageSequenceIndex = null;
            return loadingMessages[index];
        }
    }
};

function setMessage(text){
    var that = this;
    document.querySelector(".loaderContainer").classList.toggle("alternate");

    WebUtils.one(this.messageEl, "transitionend",function(){
        that.messageEl.innerHTML = text;

        document.querySelector(".loaderContainer .caption").style.transitionDelay = "2.3s";
        that.messageEl.style.opacity = 0.7;

        WebUtils.one(that.messageEl, "transitionend",function() {
            that.messageEl.style.opacity = null;
            document.querySelector(".loaderContainer .caption").style.transitionDelay = "0s";
        });
    });

    this.messageEl.style.opacity = 0;
}

module.exports = Loader;


//////////////////
// WEBPACK FOOTER
// ./js/Loader.js
// module id = 5
// module chunks = 0